import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mediaApi, type MediaUploadOptions } from '@/services/media';

interface UseMediaUploadOptions extends MediaUploadOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
  showToast?: boolean;
}

export const useMediaUpload = (options: UseMediaUploadOptions = {}) => {
  const { 
    folder = 'general', 
    maxSize,
    allowedTypes,
    onSuccess,
    onError,
    showToast = true
  } = options;

  return useMutation({
    mutationFn: (file: File) => 
      mediaApi.uploadFile(file, { folder, maxSize, allowedTypes }),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error: any) => {
      if (showToast) {
        toast.error(error.message || 'Failed to upload file');
      }
      onError?.(error);
    },
  });
};